import { Task } from '../../onethreefive/model/Task';
export const MIN_QUERY_LENGTH = 2;
export const MAX_RESULTS = 100;
export const queryWords = (query) => query.toLowerCase().split(/\s+/).filter(word => word.length > 0);
const matchesAll = (title, words) => {
    const text = (title !== null && title !== void 0 ? title : '').toLowerCase();
    return words.every(word => text.includes(word));
};
const isCompleted = (task) => task.getStatus() === 'completed';
const compare = (a, b) => {
    var _a, _b;
    const byCompleted = Number(isCompleted(a.task)) - Number(isCompleted(b.task));
    if (byCompleted !== 0) {
        return byCompleted;
    }
    const byDate = Task.compareFn(a.task, b.task);
    if (byDate !== 0) {
        return byDate;
    }
    return ((_a = a.task.getTitle()) !== null && _a !== void 0 ? _a : '').localeCompare((_b = b.task.getTitle()) !== null && _b !== void 0 ? _b : '');
};
// Every word of the query has to appear in the task title or in the subtask title.
// Open items come first, then completed ones; each group is ordered by due date.
export const searchTasks = (items, query, includeCompleted) => {
    const trimmed = query.trim();
    if (trimmed.length < MIN_QUERY_LENGTH) {
        return { results: [], total: 0 };
    }
    const words = queryWords(trimmed);
    const matches = [];
    for (const { task, subtasks } of items) {
        if (!includeCompleted && isCompleted(task)) {
            continue;
        }
        if (matchesAll(task.getTitle(), words)) {
            matches.push({ task });
        }
        for (const subtask of subtasks) {
            if (!includeCompleted && isCompleted(subtask)) {
                continue;
            }
            if (matchesAll(subtask.getTitle(), words)) {
                matches.push({ task: subtask, parent: task });
            }
        }
    }
    matches.sort(compare);
    return { results: matches.slice(0, MAX_RESULTS), total: matches.length };
};
// Splits `text` so the parts that match any query word can be shown in bold
export const highlightParts = (text, words) => {
    const escaped = words
        .filter(word => word.length > 0)
        .map(word => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    if (escaped.length === 0) {
        return [{ text, match: false }];
    }
    // splitting on a capturing group puts the matched text at the odd indexes
    return text
        .split(new RegExp(`(${escaped.join('|')})`, 'i'))
        .map((part, index) => ({ text: part, match: index % 2 === 1 }))
        .filter(part => part.text.length > 0);
};
